import { apiFetch } from './client';
import type { UserProfile } from '@/types/api';

export interface UpdateProfileInput {
  name?: string;
  headline?: string | null;
  location?: string | null;
  avatarUrl?: string | null;
}

export interface ChangePasswordInput {
  readonly currentPassword: string;
  readonly newPassword: string;
}

export const usersApi = {
  me(): Promise<UserProfile> {
    return apiFetch<UserProfile>('/users/me');
  },

  updateMe(patch: UpdateProfileInput): Promise<UserProfile> {
    return apiFetch<UserProfile>('/users/me', { method: 'PATCH', body: patch });
  },

  requestEmailChange(newEmail: string): Promise<void> {
    return apiFetch<void>('/users/me/email-change', {
      method: 'POST',
      body: { newEmail },
    });
  },

  changePassword(input: ChangePasswordInput): Promise<void> {
    return apiFetch<void>('/users/me/password', { method: 'POST', body: input });
  },

  deleteMe(password?: string): Promise<void> {
    return apiFetch<void>('/users/me', {
      method: 'DELETE',
      body: password ? { password } : undefined,
    });
  },
};
